export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6885.28d12bf1.jpg";